module.exports = __webpack_public_path__ + "static/media/menu_modelo_receituario.f9a1deb8.png";